/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientSearchResult
 */
export interface ClientSearchResult {
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    lastName: string;
    /**
     * 
     * @type {Date}
     * @memberof ClientSearchResult
     */
    birthday: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    insuranceNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    status: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    caseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    assignedCounselor: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    phone: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    country: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchResult
     */
    fullName?: string | null;
}

/**
 * Check if a given object implements the ClientSearchResult interface.
 */
export function instanceOfClientSearchResult(value: object): value is ClientSearchResult {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('birthday' in value) || value['birthday'] === undefined) return false;
    if (!('insuranceNumber' in value) || value['insuranceNumber'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('caseNumber' in value) || value['caseNumber'] === undefined) return false;
    if (!('assignedCounselor' in value) || value['assignedCounselor'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function ClientSearchResultFromJSON(json: any): ClientSearchResult {
    return ClientSearchResultFromJSONTyped(json, false);
}

export function ClientSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'birthday': (json['birthday'] == null ? null : new Date(json['birthday'])),
        'insuranceNumber': json['insuranceNumber'],
        'status': json['status'],
        'caseNumber': json['caseNumber'],
        'assignedCounselor': json['assignedCounselor'],
        'phone': json['phone'],
        'email': json['email'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
    };
}

export function ClientSearchResultToJSON(json: any): ClientSearchResult {
    return ClientSearchResultToJSONTyped(json, false);
}

export function ClientSearchResultToJSONTyped(value?: ClientSearchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'birthday': value['birthday'] == null ? value['birthday'] : `${value['birthday'].getFullYear()}-${String(value['birthday'].getMonth()+1).padStart(2,'0')}-${String(value['birthday'].getDate()).padStart(2,'0')}`,
        'insuranceNumber': value['insuranceNumber'],
        'status': value['status'],
        'caseNumber': value['caseNumber'],
        'assignedCounselor': value['assignedCounselor'],
        'phone': value['phone'],
        'email': value['email'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'fullName': value['fullName'],
    };
}

